import { render, staticRenderFns } from "./AdminMaterials.vue?vue&type=template&id=05293003"
import script from "./AdminMaterials.vue?vue&type=script&lang=js"
export * from "./AdminMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports